module.exports = __webpack_public_path__ + "img/analytics-poweredby-banner.fd50bf41.jpg";